import { h, Component, Prop } from '@stencil/core';
import { fetchPdf } from '@ccrpc/webmapgl/dist/collection/components/utils';


@Component({
  tag: 'tip-memo',
  styleUrl: 'memo.css'
})
export class Memo {
  @Prop() label: string;
  @Prop() memoTitle: string = 'title';
  @Prop() to: string = '';
  @Prop() from: string = '';
  @Prop() date: string = '';
  @Prop() re: string = '';
  @Prop() requestedAction: string = '';
  @Prop() content: any;
  @Prop() openType: 'open' | 'download' = 'download';
  @Prop() type: 'modification' | 'amendment';

  handleClick(_e) {
    fetchPdf(
      'https://ccrpc.org/pdf/',
      this.sanitize(this.memoTitle),
      this.generateMemo())
  }

  generateMemo() {
    if (this.type === 'modification') {
      return {
        template: 'cuuats',
        info: {
          title: this.memoTitle,
          author: 'CCPRC',
        },
      	content: [
      		{ text: 'Memorandum', style: 'header' },
          {
            text: [
        			{text: 'To:\t', bold: true},
        			this.to,
        		],
            style: 'address'
          },
          {
            text: [
              {text: 'From:\t', bold: true},
              this.from,
            ],
            style: 'address'
          },
          {
            text: [
              {text: 'Date:\t', bold: true},
              this.date,
            ],
            style: 'address'
          },
          {
            text: [
              {text: 'Re:\t', bold: true},
              this.re,
            ],
            style: 'address'
          },
          this.content,
      	],
        styles: {
          header: {
            fontSize: 15,
            bold: true,
            alignment: 'center',
            margin: [ 0, 5, 0, 10 ]
          },
          address: {
            margin: [ 0, 5, 0, 5 ]
          },
          content: {
            margin: [ 0, 10, 0, 10 ]
          }
        }
      }
    }

    if (this.type === 'amendment') {
      return {
        template: 'cuuats',
        info: {
          title: this.memoTitle,
          author: 'CCPRC',
        },
      	content: [
      		{ text: 'Memorandum', style: 'header' },
          {
            text: [
        			{text: 'To:\t', bold: true},
        			this.to,
        		],
            style: 'address'
          },
          {
            text: [
              {text: 'From:\t', bold: true},
              this.from,
            ],
            style: 'address'
          },
          {
            text: [
              {text: 'Date:\t', bold: true},
              this.date,
            ],
            style: 'address'
          },
          {
            text: [
              {text: 'Re:\t', bold: true},
              this.re,
            ],
            style: 'address'
          },
          {
            text: [
              {text: 'Requested Action: ', bold: true},
              this.requestedAction,
            ],
            style: 'address'
          },
          this.content,
      	],
        styles: {
          header: {
            fontSize: 15,
            bold: true,
            alignment: 'center',
            margin: [ 0, 5, 0, 10 ]
          },
          address: {
            margin: [ 0, 5, 0, 5 ]
          },
          content: {
            margin: [ 0, 10, 0, 10 ]
          }
        }
      }
    }
  }

  sanitize(string) {
    return string.replace(/[\W_]+/g,"-");
  }

  render() {
    return (
      <ion-button onClick={ (e) => this.handleClick(e)} size='small'>
        <ion-icon name="document" slot='start'></ion-icon>{this.label}
      </ion-button>
    )
  }
}
